// src/routes/AuthRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';
import AuthLayout from '../components/layout/AuthLayout';

// Auth Pages
import Login from '../pages/auth/Login';
import Register from '../pages/auth/Register';
import ForgotPassword from '../pages/auth/ForgotPassword';
import VerifyOTP from '../pages/auth/VerifyOTP';
import ResetPassword from '../pages/auth/ResetPassword';
import EmailVerification from '../pages/auth/EmailVerification';

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AuthLayout />}>
        <Route index element={<Navigate to="login" replace />} />
        
        <Route path="login" element={
          <>
            <Helmet>
              <title>Login - MediGo Healthcare Platform</title>
              <meta name="description" content="Sign in to your MediGo account to access healthcare services, book consultations, and manage your health." />
              <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Login />
          </>
        } />
        
        <Route path="register" element={
          <>
            <Helmet>
              <title>Register - Join MediGo Healthcare Platform</title>
              <meta name="description" content="Create your MediGo account to access healthcare services as a patient, doctor, hospital, or pharmacy." />
              <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Register />
          </>
        } />
        
        <Route path="forgot-password" element={
          <>
            <Helmet>
              <title>Forgot Password - MediGo Account Recovery</title>
              <meta name="description" content="Reset your MediGo account password securely." />
              <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <ForgotPassword />
          </>
        } />
        
        <Route path="verify-otp" element={
          <>
            <Helmet>
              <title>Verify OTP - MediGo</title>
              <meta name="description" content="Enter the verification code sent to your email or phone to verify your identity." />
              <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <VerifyOTP />
          </>
        } />
        
        <Route path="reset-password" element={
          <>
            <Helmet>
              <title>Reset Password - MediGo</title>
              <meta name="description" content="Create a new password for your MediGo account." />
              <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <ResetPassword />
          </>
        } />
        
        <Route path="verify-email" element={
          <>
            <Helmet>
              <title>Email Verification - MediGo</title>
              <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <EmailVerification />
          </>
        } />
      </Route>
    </Routes>
  );
};

export default AuthRoutes;